<div class="section-div">
  <div class="content-div">
    <img src="/assets/icons/build-plan/bulb.svg" alt="profile" />
    <p class="description">
      Complete your checklist to unlock your personalized plan. 
      Once ready, you’ll get your Skillprint. a snapshot view of your key strengths, 
      and an Action Plan towards your future career goal.
    </p>
  </div>
  <div class="btn-div">
    <button 
      mat-flat-button 
      type="button" 
      class="btn"
      [class]="`${planUnlocked ? 'btn-unlocked' : 'btn-locked'}`"
      (click)="onClickBtn()"
    >
      <p class="btn-text">Generate Plan</p>
      @if (!planUnlocked) {
        <img src="/assets/icons/build-plan/lock.svg" alt="profile" />
      }
    </button>
  </div>
</div>